import '../styles/Banner.css'
import logo from '../assets/logo.png'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import { useNouveauxMurs } from "./useNouveauxMurs.ts";



function Banner() {
    const title = 'Kass Brick'
    const { user, logout } = useAuth()
    const navigate = useNavigate()
    const aDesNouveauxMurs = useNouveauxMurs(user?.id);

    const handleLogout = () => {
        logout()
        navigate("/")
    }

    return (
        <div className="lmj-banner">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={logo} alt='Kass Brick' className='lmj-logo' />
                <h1 className='lmj-title'>{title}</h1>
            </div>
            <nav>
                {user ? (
                    <>
                        <Link to="/">Liste des murs</Link>
                        {user?.role === "USER" && (
                            <Link to="/nouveaux-murs" className="retro-btn">
                                Nouveaux murs
                               {aDesNouveauxMurs && (
  <span
    style={{
      marginLeft: 6,
      width: 10,
      height: 10,
      borderRadius: "50%",
      backgroundColor: "red",
      display: "inline-block",
    }}
  />
)}
                                </Link>
                        )}
                        <Link to="/Creer-Mur">Créer un mur</Link>
                        {user.role === 'ADMIN' && (
                            <Link to="/admin/utilisateurs">Gérer les utilisateurs</Link>
                        )}

                        <button onClick={handleLogout} className="logout-btn">Se déconnecter</button>
                    </>
                ) : (
                    <Link to="/connexion">Se connecter</Link>
                )}
            </nav>
        </div>
    )
}
export default Banner